import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

export const fetchFinancialYears = async (params = {}) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/financial-year/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching financial years:", error);
    throw error;
  }
};

export const fetchFinancialYearById = async (id) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}localization/financial-year/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching financial year details:", error);
    throw error;
  }
};

export const createFinancialYear = async (payload) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}localization/financial-year/`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating financial year:", error);
    throw error;
  }
};

export const updateFinancialYear = async (id, payload) => {
  try {
    const response = await authenticatedAxios.put(`${baseurl}localization/financial-year/${id}/`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating financial year:", error);
    throw error;
  }
};

export const deleteFinancialYear = async (id) => {
  try {
    const response = await authenticatedAxios.delete(`${baseurl}localization/financial-year/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error deleting financial year:", error);
    throw error;
  }
};
